namespace GeniuzPOS.AdvPromo {
    export interface Report_Adv03Row {
        ShopId?: string;
        ShopName?: string;
        ShopFullName?: string;
        PromoCampaign?: string;
        PmGroupId?: string;
        PmId?: string;
        SalesQty?: number;
        SalesAmtBeforePromo?: number;
        PromoDisc?: number;
        SalesAmtAfterPromo?: number;
    }

    export namespace Report_Adv03Row {
        export const idProperty = 'ShopId';
        export const nameProperty = 'ShopFullName';
        export const localTextPrefix = 'AdvPromo.Report_Adv03';
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:ยอดขายโปรโมชั่น:View';

        export declare const enum Fields {
            ShopId = "ShopId",
            ShopName = "ShopName",
            ShopFullName = "ShopFullName",
            PromoCampaign = "PromoCampaign",
            PmGroupId = "PmGroupId",
            PmId = "PmId",
            SalesQty = "SalesQty",
            SalesAmtBeforePromo = "SalesAmtBeforePromo",
            PromoDisc = "PromoDisc",
            SalesAmtAfterPromo = "SalesAmtAfterPromo"
        }
    }
}
